export { default } from './unsupportedProp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/unsupportedProp/index.js
// module id = 747
// module chunks = 22